"use strict";

exports.__esModule = true;
exports.default = void 0;

function createContext(selector) {
  return new Promise(function (resolve) {
    var context = my.createCanvasContext(selector);
    Object.defineProperty(context, 'fillStyle', {
      get: function get() {
        return context.setFillStyle;
      },
      set: function set(value) {
        context.setFillStyle(value);
      }
    });
    resolve(context);
  });
}

var _default = createContext;
exports.default = _default;